import { Badge } from "@mantine/core"

export function VisibilityBadge({ publiclyVisible, visibility, size }) {
  const isPublic = typeof publiclyVisible === "boolean" ? publiclyVisible : visibility === "public"

  return (
    <Badge variant="light" color={isPublic ? "green" : "gray"} size={size} className="af-visibility-badge">
      {isPublic ? "Public" : "Private"}
    </Badge>
  )
}
